import { normalSanatizerBRL } from "src/utils/functions";
import { RescisaoResult } from "../utils/rescisao.d";

export const RescisaoTable = ({ results }: { results: RescisaoResult }) => {
  return (
    <div className="max-h-[400px] overflow-y-auto m-auto overflow-x-auto">
      <table className="bg-white rounded w-full max-h-[400px] overflow-y-auto">
        <thead className="bg-gray-200 sticky top-0">
          <tr>
            <th className="px-4 py-2 text-center truncate">Descrição</th>
            <th className="px-4 py-2 text-center truncate">Valores</th>
          </tr>
        </thead>
        <tbody>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Rescisão
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.rescisao)}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">FGTS</td>
            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.FGTS)}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Multa de FGTS
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.multaFGTS)}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Saldo Salário
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.saldoSalario)}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              13° salário proporcional
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.decimoProporcional)}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Ferias Vencidas
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.feriasVencidas)}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Aviso Prévio
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.avisoPrevio)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};